import React from "react"

const Row = ({ children }) => {
    return (
        <div className="row block lg:flex items-center justify-content my-3">
            {children}
        </div>
    )
}

const Col = ({ children }) => {
    return (
        <div className="flex-1 p-2">
            {children}
        </div>
    )
}

/* --------------------------------------------------------------------------
   Oferta — pricing cards
   -------------------------------------------------------------------------- */

const PricingSection = ({ eyebrow, title, children }) => {
    return (
        <section className="pricing-section mt-16 lg:mt-24">
            <header className="mb-8 lg:mb-10">
                {eyebrow && <p className="eyebrow eyebrow-line">{eyebrow}</p>}
                {title && (
                    <h3 className="pricing-section-title mt-3">{title}</h3>
                )}
            </header>
            {children}
        </section>
    )
}

const PricingGrid = ({ children }) => {
    return (
        <div className="pricing-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {children}
        </div>
    )
}

const PricingCard = ({ title, price, priceNote, featured, children }) => {
    // Prices that contain a digit render as large display figures; the
    // rest (e.g. "w cenie zabiegu", "indywidualnie") render as small caps.
    const hasDigits = /\d/.test(price || "")
    return (
        <div className={`pricing-card${featured ? " featured" : ""}`}>
            {featured && (
                <span className="pricing-badge">Najczęściej wybierana</span>
            )}
            <div className="pricing-card-body">
                <h4 className="pricing-card-title">{title}</h4>
                {children && (
                    <div className="pricing-card-desc mt-3">{children}</div>
                )}
            </div>
            <div className="pricing-foot">
                <div className={`pricing-price${hasDigits ? "" : " text"}`}>
                    {price}
                </div>
                {priceNote && (
                    <div className="pricing-note">{priceNote}</div>
                )}
            </div>
        </div>
    )
}

const PricingInfoGrid = ({ children }) => {
    return (
        <div className="pricing-info-grid grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {children}
        </div>
    )
}

const PricingInfo = ({ title, value, note }) => {
    return (
        <div className="pricing-info">
            <p className="eyebrow">{title}</p>
            <div className="pricing-info-value mt-4">{value}</div>
            {note && <p className="pricing-info-note mt-2">{note}</p>}
        </div>
    )
}

export {
    Row,
    Col,
    PricingSection,
    PricingGrid,
    PricingCard,
    PricingInfoGrid,
    PricingInfo,
}
